<template>
  <div class="fallback">
    <div class="bg" aria-hidden="true"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.fallback { position: absolute; inset: 0; overflow: hidden; }
.bg {
  width: 100%;
  height: 100%;
  background: radial-gradient(120% 120% at 20% 20%, #2b2d3a 0%, transparent 60%),
              radial-gradient(120% 120% at 80% 30%, #0a0b14 0%, transparent 60%),
              radial-gradient(140% 140% at 50% 80%, #1a103a 0%, transparent 60%),
              linear-gradient(180deg, #05060a 0%, #0a0b14 100%);
  filter: contrast(105%) saturate(108%);
  animation: drift 12s ease-in-out infinite alternate;
}
@keyframes drift {
  0% { transform: translate3d(0,0,0) scale(1); }
  100% { transform: translate3d(0,-1.5%,0) scale(1.02); }
}
</style>
